import Vue from 'vue'
// models component
import ShipDaily from '@/models/ShipDaily'

export default class ShipDailyFetch {
    // Ship DailyReport Fetch
    static of(shipId, params) {
        return Promise.resolve()
            .then(function () {
                ShipDaily.deleteAll()
                return ShipDaily.api()
                    .fetch(shipId, params)
                    .then(function (result) {
                        console.log('ShipDaily.all()', ShipDaily.all())
                    })
            })
            .catch(() => {
                return new Promise((resolve, reject) => {
                    reject(new Error())
                })
            })
    }
}
